import { axiosInstance } from '../utils/axios';

export const getPrivateMessageList = (channelUID, extraData) =>
  axiosInstance.get(`/messages`, extraData);

export const getChannelMessageList = (channelUID, extraData) =>
  axiosInstance.get(`${channelUID}/messages`, extraData);

export const getUnreadMessageList = (channelUID, extraData) =>
  axiosInstance.get('/messages/unread', extraData);

// TODO: add type params once backend implements feature to fetch files data
export const getPrivateMessages = (userId, extraData) =>
  axiosInstance.get(`/messages/${userId}`, extraData);

export const getChannelMessages = (channelUid, extraData) =>
  axiosInstance.get(`/${channelUid}/messages`, extraData);

export const postMessageToUser = ({ userId, message, type }, extraData) =>
  axiosInstance.post(`/messages/${userId}`, { message, type }, extraData);

export const postMessageToChannel = (
  { channelUid, message, type },
  extraData,
) => axiosInstance.post(`${channelUid}/messages`, { message, type }, extraData);
